var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "farmingon2-slide column-slide"
  }, [_c('swiper', {
    staticClass: "swiper",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, [_vm._l(_vm.images, function (image, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('v-card', {
      staticClass: "square-img-card",
      attrs: {
        "rounded": ""
      },
      on: {
        "click": function click($event) {
          return _vm.openDialog(index);
        }
      }
    }, [_c('div', {
      staticClass: "square-img",
      style: 'background-image:url(' + image.img + ');'
    })])], 1);
  }), _c('div', {
    staticClass: "swiper-control",
    attrs: {
      "slot": "pagination"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
      }
    },
    slot: "pagination"
  }, [_c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }, [_c('icon-arrow-rounded')], 1), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }, [_c('icon-arrow-rounded', {
    attrs: {
      "direction": "right"
    }
  })], 1)])], 2), _c('u-dialog', {
    attrs: {
      "eager": "",
      "width": "800",
      "overlay-opacity": "0.9",
      "content-class": "dialog-slide"
    },
    model: {
      value: _vm.dialogOpen,
      callback: function callback($$v) {
        _vm.dialogOpen = $$v;
      },
      expression: "dialogOpen"
    }
  }, [_c('div', {
    staticClass: "swiper-dialog"
  }, [_c('swiper', {
    ref: "swiperDialog",
    attrs: {
      "options": _vm.swiperDialogOptions
    }
  }, [_vm._l(_vm.images, function (image, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('img', {
      staticClass: "swiper-dialog__img",
      attrs: {
        "src": image.img
      }
    })]);
  }), _c('div', {
    staticClass: "swiper-control",
    attrs: {
      "slot": "pagination"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
      }
    },
    slot: "pagination"
  }, [_c('div', {
    staticClass: "swiper-button-prev"
  }, [_c('icon-arrow-rounded')], 1), _c('div', {
    staticClass: "swiper-button-next"
  }, [_c('icon-arrow-rounded', {
    attrs: {
      "direction": "right"
    }
  })], 1)])], 2)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }